export type AmountLimitViolation = "hardMax" | "softMax" | "softMin";

/**
 * Checks a normalized amount against the subcategory limits. Soft limits the
 * user has already confirmed are skipped; the hard maximum never is.
 */
export const getAmountLimitViolation = (
  amount: string,
  limits?: {
    hardMaxAmount?: string;
    softMaxAmount?: string;
    softMinAmount?: string;
  },
  confirmed: { softMax?: boolean; softMin?: boolean } = {},
): AmountLimitViolation | undefined => {
  const value = parseFloat(amount);
  if (!!limits?.hardMaxAmount && value >= parseInt(limits.hardMaxAmount)) {
    return "hardMax";
  }
  if (
    !!limits?.softMaxAmount &&
    !confirmed.softMax &&
    value >= parseInt(limits.softMaxAmount)
  ) {
    return "softMax";
  }
  if (
    !!limits?.softMinAmount &&
    !confirmed.softMin &&
    value <= parseInt(limits.softMinAmount)
  ) {
    return "softMin";
  }
};
